import { getWacInfoQueueShift, queueGetWacInfo } from '../actions/internalActions';
import store from '../store/store';
import { mutator } from 'satcheljs';

mutator(queueGetWacInfo, actionMessage => {
    const { url } = actionMessage;
    store.getWacInfoQueue.push(url);
});

mutator(getWacInfoQueueShift, () => {
    store.getWacInfoQueue.shift();
});
